export default __webpack_public_path__ + "static/media/logo-sinfin-new.555df183.svg";